__turbopack_context__.v({
  "categories": "searchGrid-module-scss-module__dUgI8q__categories",
  "category": "searchGrid-module-scss-module__dUgI8q__category",
  "categoryCount": "searchGrid-module-scss-module__dUgI8q__categoryCount",
  "categoryName": "searchGrid-module-scss-module__dUgI8q__categoryName",
  "form": "searchGrid-module-scss-module__dUgI8q__form",
  "noResults": "searchGrid-module-scss-module__dUgI8q__noResults",
  "pagination": "searchGrid-module-scss-module__dUgI8q__pagination",
  "paginationList": "searchGrid-module-scss-module__dUgI8q__paginationList",
  "productLink": "searchGrid-module-scss-module__dUgI8q__productLink",
  "productList": "searchGrid-module-scss-module__dUgI8q__productList",
  "sorting": "searchGrid-module-scss-module__dUgI8q__sorting",
  "sortingBy": "searchGrid-module-scss-module__dUgI8q__sortingBy",
});
